import { render, staticRenderFns } from "./RolesChip.vue?vue&type=template&id=0bb138ab&"
import script from "./RolesChip.vue?vue&type=script&lang=js&"
export * from "./RolesChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports